import { render, staticRenderFns } from "./sfc-simple-email-capture.vue?vue&type=template&id=1834556e&scoped=true&lang=pug&"
import script from "./sfc-simple-email-capture.vue?vue&type=script&lang=js&"
export * from "./sfc-simple-email-capture.vue?vue&type=script&lang=js&"
import style0 from "./sfc-simple-email-capture.vue?vue&type=style&index=0&id=1834556e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1834556e",
  null
  
)

export default component.exports